<template>
  <div class="dipContainer" style="text-align:left;">
    <div
      v-if="!ishidden"
      style="width:100vw;height:100vh;position:absolute;z-index:1000000;background-color:#e7e7e7;"
    >
      <h1>Génération en cours...</h1>
    </div>

    <div
      class="canvas-container"
      v-if="!ishidden"
      id="canvas-global"
      v-bind:style="'background-image : url(' + url_bg + ')'"
    >
      <div
        v-for="parameter in parameters"
        class=" container_value"
        v-bind:style="{
          color: parameter.couleur,
          fontSize: parameter.taille + 'px',
          fontFamily: parameter.police,
          transform: 'rotate(' + parameter.rotate + 'deg)',
          top: parameter.offsetY + 'px',
          left: parameter.offsetX + 'px',
          fontStyle: parameter.fontStyle,
          fontWeight: parameter.fontWeight,
          display: parameter.display
        }"
      >
        <p class="distance_text">
          {{ parameter.value }}
        </p>
      </div>
    </div>

    <img
      :src="url_generate"
      style="width:100vw;height:auto;max-width:1100px;mmargin:10px;"
    />
    <b-row style="margin-top:10px;margin-left:20px;">
      <b-col style="text-align:left;">
        <a download="Diplome-Sportips.png" :href="image" ref="downbtn">
          <b-button style="margin-top:30px;">Télécharger mon diplôme</b-button>
        </a>
      </b-col>
    </b-row>
    <b-row style="margin-top:10px;margin-left:20px;">
      <b-col style="text-align:left;">
        <b-button @click="downloadDiplome" style="margin-top:30px;"
          >Partager sur facebook</b-button
        >
      </b-col>
    </b-row>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["id", "nbc", "nbs", "e"
  ],
  data() {
    return {
      id_epreuve : 0,
      image: "",
      values: {
        nom: "Bon",
        prenom: "Jean",
        distance: "10KM",
        classement: "1/302",
        temps: "00:25:00",
        club: "Club des oliviers",
        vitesse: "17,4 km/h",
        classement_cat: "1/120 (ESM)"
      },
      url_generate: "",
      ishidden: false,
      url_bg: "",
      url_flyer: "",
      publish: false,
      epreuves: [],
      selected_epreuve: 0,
      parameters: {
        nom: {
          name: "nom",
          value: "BON",
          display: "none",
          fontWeight: "normal",
          fontStyle: "normal",
          offsetX: 0,
          offsetY: 0,
          police: "",
          taille: 40,
          couleur: "black",
          rotate: 0
        },
        prenom: {
          name: "prenom",
          value: "Jean",
          display: "none",
          fontWeight: "normal",
          fontStyle: "normal",
          offsetX: 0,
          offsetY: 0,
          police: "",
          taille: 40,
          couleur: "black",
          rotate: 0
        },
        distance: {
          name: "distance",
          value: "10KM",
          display: "none",
          fontWeight: "normal",
          fontStyle: "normal",
          offsetX: 0,
          offsetY: 0,
          police: "",
          taille: 40,
          couleur: "black",
          rotate: 0
        },
        classement: {
          name: "classement",
          value: "1/302",
          display: "none",
          fontWeight: "normal",
          fontStyle: "normal",
          offsetX: 0,
          offsetY: 0,
          police: "",
          taille: 40,
          couleur: "black",
          rotate: 0
        },
        temps: {
          name: "temps",
          value: "00:25:00",
          display: "none",
          fontWeight: "normal",
          fontStyle: "normal",
          offsetX: 0,
          offsetY: 0,
          police: "",
          taille: 40,
          couleur: "black",
          rotate: 0
        },
        club: {
          name: "club",
          value: "Club des oliviers",
          display: "none",
          fontWeight: "normal",
          fontStyle: "normal",
          offsetX: 0,
          offsetY: 0,
          police: "",
          taille: 40,
          couleur: "black",
          rotate: 0
        },
        vitesse: {
          name: "vitesse",
          value: "17,4 km/h",
          display: "none",
          fontWeight: "normal",
          fontStyle: "normal",
          offsetX: 0,
          offsetY: 0,
          police: "",
          taille: 40,
          couleur: "black",
          rotate: 0
        },
        classement_cat: {
          name: "classement catégorie",
          value: "1/120 (ESM)",
          display: "none",
          fontWeight: "normal",
          fontStyle: "normal",
          offsetX: 0,
          offsetY: 0,
          police: "",
          taille: 40,
          couleur: "black",
          rotate: 0
        }
      },
      fonts: [
        {
          value: "Roboto",
          text: "Roboto"
        },
        {
          value: "Open Sans",
          text: "Open Sans"
        },
        {
          value: "Lato",
          text: "Lato"
        },
        {
          value: "Montserrat",
          text: "Montserrat"
        },
        {
          value: "Roboto Condensed",
          text: "Roboto Condensed"
        },
        {
          value: "Source Sans Pro",
          text: "Source Sans Pro"
        },
        {
          value: "Oswald",
          text: "Oswald"
        },
        {
          value: "Raleway",
          text: "Raleway"
        },
        {
          value: "Merriweather",
          text: "Merriweather"
        },
        {
          value: "Roboto Slab",
          text: "Roboto Slab"
        },
        {
          value: "Slabo 27px",
          text: "Slabo 27px"
        },
        {
          value: "PT Sans",
          text: "PT Sans"
        },
        {
          value: "Poppins",
          text: "Poppins"
        },
        {
          value: "Noto Sans",
          text: "Noto Sans"
        },
        {
          value: "Ubuntu",
          text: "Ubuntu"
        },
        {
          value: "Heebo",
          text: "Heebo"
        },
        {
          value: "Open Sans Condensed",
          text: "Open Sans Condensed"
        },
        {
          value: "Playfair Display",
          text: "Playfair Display"
        }
      ]
    };
  },
  methods: {
    createDiplome() {
      html2canvas(document.querySelector("#canvas-global"), {
        logging: true
      }).then(canvas => {

        var image = canvas
          .toDataURL("image/png")
          .replace("image/png", "image/octet-stream");

        this.image = image;
        var data = new FormData();
        var _this = this;
        data.append("data", this.image);
        data.append("name", "Diplome Sportips - " + this.values.nom);
        axios
          .post(
            `https://sportips.fr/plateformeResultats/uploads/D/uploadGeneratedDiplome.php`,
            data
          )
          .then(function(response) {
            _this.url_generate =
              "https://sportips.fr/plateformeResultats/uploads/D/" +
              response.data;
            _this.ishidden = true;
            var elem = _this.$refs.downbtn;
            elem.click();
          });
      });
    },
    downloadDiplome() {
      FB.ui(
        {
          method: "feed",
          link: this.url_generate
        },
        function(response) {}
      );
    },

      loadCoureurInfos(id) {
      var data = new FormData();
      var _this = this;
      data.append("id", id);

      axios
        .post(
          `https://sportips.fr/plateformeResultats/getCoureurInfos.php`,
          data
        )
        .then(function(response) {
          _this.id_epreuve = response.data[0].id_epreuve;
          _this.values.nom = response.data[0].nom;
          _this.values.prenom = response.data[0].prenom;
          _this.values.distance = parseInt(response.data[0].distance) + " km";
          _this.values.classement = response.data[0].classement;
          _this.values.temps = response.data[0].temps_arrondi;
          _this.values.club = response.data[0].club;
          var moyenne =
            parseFloat(response.data[0].distance.replace(",", ".")) /
            parseFloat(response.data[0].nb_heures_arrondi.replace(",", "."));
          moyenne = moyenne.toFixed(2);
          _this.values.vitesse = moyenne;
          _this.values.classement_cat =
            response.data[0].classement_par_cat +
            "/" +
            _this.$route.query.nbc +
            " " +
            response.data[0].abbrev_categorie;
          _this.values.classement_sexe =
            response.data[0].classement_par_sexe +
            "/" +
            _this.$route.query.nbs +
            " " +
            response.data[0].sexe;
          _this.values.nom_epreuve = _this.$route.query.e;
          _this.getDiplomeBG();
        });
    },
    getDiplomeBG(){
          var _this = this;
    var data = new FormData();
    data.append("id_course", this.id_epreuve);
    axios
      .post(`https://sportips.fr/plateformeResultats/getDiplome.php`, data)
      .then(function(response) {
        var res = response.data;
        _this.url_bg = res.url_bg;
        _this.url_flyer = res.flyer;

        for (var i = 0; i < res.parameters.length; i++) {
          var param = res.parameters[i];
          if (param.name === "nom") {
            _this.parameters.nom = {
              name: param.name,
              value: _this.values.nom,
              display: param.display,
              fontWeight: param.font_weight,
              fontStyle: param.font_style,
              offsetX: param.offset_x,
              offsetY: param.offset_y,
              police: param.police,
              taille: param.taille,
              couleur: param.couleur,
              rotate: param.rotate
            };
          }
          if (param.name === "prenom") {
            _this.parameters.prenom = {
              name: param.name,
              value: _this.values.prenom,
              display: param.display,
              fontWeight: param.font_weight,
              fontStyle: param.font_style,
              offsetX: param.offset_x,
              offsetY: param.offset_y,
              police: param.police,
              taille: param.taille,
              couleur: param.couleur,
              rotate: param.rotate
            };
          }
          if (param.name === "distance") {
            if (screen.width >= 480 && param.police === "EVT Paint") {
              param.offset_y = param.offset_y - 40;
            }
            _this.parameters.distance = {
              name: param.name,
              value: _this.values.distance,
              display: param.display,
              fontWeight: param.font_weight,
              fontStyle: param.font_style,
              offsetX: param.offset_x,
              offsetY: param.offset_y,
              police: param.police,
              taille: param.taille,
              couleur: param.couleur,
              rotate: param.rotate
            };
          }
          if (param.name === "temps") {
            if (screen.width >= 480 && param.police === "EVT Paint") {
              param.offset_y = param.offset_y - 35;
            }
            _this.parameters.temps = {
              name: param.name,
              value: _this.values.temps,
              display: param.display,
              fontWeight: param.font_weight,
              fontStyle: param.font_style,
              offsetX: param.offset_x,
              offsetY: param.offset_y,
              police: param.police,
              taille: param.taille,
              couleur: param.couleur,
              rotate: param.rotate
            };
          }
          if (param.name === "club") {
            _this.parameters.club = {
              name: param.name,
              value: _this.values.club,
              display: param.display,
              fontWeight: param.font_weight,
              fontStyle: param.font_style,
              offsetX: param.offset_x,
              offsetY: param.offset_y,
              police: param.police,
              taille: param.taille,
              couleur: param.couleur,
              rotate: param.rotate
            };
          }
          if (param.name === "classement") {
            _this.parameters.classement = {
              name: param.name,
              value: _this.values.classement,
              display: param.display,
              fontWeight: param.font_weight,
              fontStyle: param.font_style,
              offsetX: param.offset_x,
              offsetY: param.offset_y,
              police: param.police,
              taille: param.taille,
              couleur: param.couleur,
              rotate: param.rotate
            };
          }
          if (param.name === "vitesse") {
            _this.parameters.vitesse = {
              name: param.name,
              value: _this.values.vitesse,
              display: param.display,
              fontWeight: param.font_weight,
              fontStyle: param.font_style,
              offsetX: param.offset_x,
              offsetY: param.offset_y,
              police: param.police,
              taille: param.taille,
              couleur: param.couleur,
              rotate: param.rotate
            };
          }
          if (param.name === "classement catégorie") {
            _this.parameters.classement_cat = {
              name: param.name,
              value: _this.values.classement_cat,
              display: param.display,
              fontWeight: param.font_weight,
              fontStyle: param.font_style,
              offsetX: param.offset_x,
              offsetY: param.offset_y,
              police: param.police,
              taille: param.taille,
              couleur: param.couleur,
              rotate: param.rotate
            };
          }
        }

        setTimeout(() => _this.createDiplome(), 1000);
      });
    }
},

  created: function() {
    this.loadCoureurInfos(this.$route.query.id);



  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@font-face {
  font-family: vvx;
  src: url("https://sportips.fr/plateformeResultats/fonts/Predator0316-Sans-Cut.ttf");
}
@font-face {
  font-family: LemonMilk;
  src: url('https://sportips.fr/plateformeResultats/fonts/LEMONMILK-Medium.ttf');
}

@import url("https://fonts.googleapis.com/css?family=Heebo|Lato|Merriweather|Montserrat|Noto+Sans|Open+Sans|Open+Sans+Condensed:300|Oswald|PT+Sans|Playfair+Display|Poppins|Raleway|Roboto|Roboto+Condensed|Roboto+Slab|Slabo+27px|Source+Sans+Pro|Ubuntu");

.container_value {
  position: absolute;
}

.canvas-container {
  position: fixed;
  overflow: visible !important;
  width: 1100px !important;
  height: 707px !important;
  background-position: top left;
  background-repeat: none;
}

@media only screen and (max-width: 1100px) {
  .imgRendered {
    display: none;
  }
}

.hidden {
  display: none;
}

.fullcontainer {
  overflow: visible !important;
  position: fixed;
  background-position: left center;
  background-size: cover;
  width: 1100px !important;
  height: 707px !important;
}
.dipContainer {
  width: 1100px !important;
  height: 707px !important;
  overflow: visible !important;
}

#download {
  position: fixed;
}

.header-tab {
  padding: 15px;
  background-color: #e7e7e7;
}
</style>



// WEBPACK FOOTER //
// src/components/GetDiploma.vue